import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";

import Dashboard from "../../../mui/Dashboard";
import { AninharView, menuRotas, rotas } from "../../../services/router";
import { db } from "../../../services/db";
import { useEffect, useState } from "react";
import { PageDegrade } from "../../../mui/PageDegrade";
import { Box, Button, CircularProgress, CssBaseline, LinearProgress, Skeleton, Stack, Typography } from "@mui/material";

import Alerts from "../../../components/alerts/Alerts";
import { Login } from "@mui/icons-material";
import { SplashScreen } from "./splash";
import { mapDispatchToStatusAppProps, mapStateToStatusAppProps, StatusAppViewProps } from "../root.controller";
import { startRouterLogIn } from "../../logIn/logIn.router";


function Rootview(props: StatusAppViewProps) {
    const { start,credencial } = props.statusAppState
    const { logOff } = props.usuarioActions
    const usuario = props.usuarioState.rowLogado

    //menuRotas[0].eventOnClick();
    useEffect(() => {
        console.log("chamou useEffec em rootView", props)
        if (!credencial._id || !usuario._id)
                rotas.navigate("/logIn")
    }, [start,usuario])


    if (start && usuario._id) {
        return (
            <Dashboard
                menuProps={{
                    listItens: menuRotas,
                    funcLogado: { conta: credencial,usuario:usuario},
                    logout: () => logOff(),
                    versao: props.statusAppState.versao

                }} 
                propsApp={props}
            >
                <AninharView />
            </Dashboard>
        )
    }

    return (
        <PageDegrade>
            <CssBaseline />
            <SplashScreen loading={props.statusAppState.loading} msg={props.statusAppState.msg} />
        </PageDegrade>
    )
}



export default connect(mapStateToStatusAppProps, mapDispatchToStatusAppProps)(Rootview);